<template>
  <div>
    <div class="page-stat--body">
      <div v-for="(stat, index) in stats" :key="index" class="page-stat--card flex-stats">
        <div class="stat">
          <div class="stat-description is-flex is-justify-between">
            <p class="font-md text-grey-tertiary">
              {{ stat.label }}
            </p>
          </div>
        </div>
        <div class="stat-figure">
          <h5>{{ loading ? "-" : stat.figure }}</h5>
          <div class="" v-if="stat.label === 'Overall Rating'">
            <el-rate v-model="overview.feedback_average" disabled />
          </div>
        </div>
      </div>
      <div class="page-stat--card">
        <div v-for="(item, index) in sortedRatings" :key="index" class="is-flex is-align-center">
          <div class="mr-2">{{ item.rating }}</div>
          <el-progress class="ml-0 style-bar" :percentage="item.percentage" :stroke-width="8" :show-text="false"></el-progress>
          <div class="ml-2">{{ item.percentage.toFixed(2) }}%</div>
        </div>
      </div>
    </div>

    <eden-table-actions :title="title" @search="search" class="mt-3">
      <template slot="actions">
        <reviews-filter :disabled="loading" :clear="filterParams.clear" @filter="filter" />
      </template>
    </eden-table-actions>
    <div>
      <eden-loader v-if="loading" />
      <template v-else>
        <eden-filter-items v-if="filterParams.status" :params="filterParams.paramsLabel" @clear-filter="clearFilter"
          @clear-filters="clearFilters" />
        <template v-if="feedback.length">
          <el-table :data="feedback">
            <el-table-column width="100">
              <template slot="header">
                <span>Order ID</span>
              </template>
              <template slot-scope="scope">
                <router-link class="text-primary" :to="{
                  name: 'orders.order',
                  params: { id: scope.row.customer_order_id },
                }">
                 #{{ scope.row.customer_order_id }}</router-link>
              </template>
            </el-table-column>

            <el-table-column width="350">
              <template slot="header">
                <span>Review</span>
              </template>
              <template slot-scope="scope">
                <reviews-title :id="scope.row.id" :rate="scope.row.rating" :review="scope.row.rating_description"
                :comments="scope.row.description" :tags="scope.row.tags" />
              </template>
            </el-table-column>

            <el-table-column width="200">
              <template slot="header">
                <span class="font-sm"> Customer </span>
              </template>
              <template slot-scope="scope">
                <router-link :to="{
                  name: 'customers.individual',
                  params: { id: scope.row.customer_id },
                }">
                  <span class="font-sm text-primary">
                    {{ formatName(scope.row.customer_name) }}</span></router-link>
                <span class="font-xsm lowercase">{{ scope.row.customer_email }}</span>
              </template>
            </el-table-column>

            <el-table-column width="200">
          <template slot="header">
            <span class="eden-table-header"> Service </span>
          </template>
          <template slot-scope="scope">
            <div class="is-flex is-align-center"></div>
            <el-tag
              :type="setServiceType(scope.row.service)"
              >{{ formatText(scope.row.service) }}</el-tag
            >
          </template>
        </el-table-column>

            <el-table-column width="180">
          <template slot="header">
            <span>Order type</span>
          </template>
          <template slot-scope="scope">
            <p>
              {{ unformatSlug(scope.row.service_type) }}
            </p>
          </template>
        </el-table-column>

        <el-table-column width="160">
            <template slot="header">
              <div class="table--header">
                <span>Order Delivery Date</span>
              </div>
            </template>
            <template slot-scope="scope">
              <p>{{ formatDate(scope.row.customer_order_delivery_date, "do m,y") }}</p>
            </template>
          </el-table-column>


        <el-table-column width="160">
            <template slot="header">
              <div class="table--header">
                <span>Feedback Created</span>
              </div>
            </template>
            <template slot-scope="scope">
              <p>{{ formatDate(scope.row.feedback_created_at, "do m,y") }}</p>
            </template>
          </el-table-column>

          
          </el-table>
          <eden-pagination v-if="showPagination" :from="from" :to="pagination.to" :total="pagination.total" :current-page.sync="page" />
        </template>
        <eden-content-empty v-else :text="'No data'" />
      </template>
    </div>
  </div>

</template>

<script>
import { formatSuggestions } from "@/components/Feedback/Suggestions/suggestions.config";
import feedback from "@/requests/feedback/reviews";
import ReviewsTitle from "../ReviewsTitle.vue";
import ReviewsFilter from "@/components/Feedback/Reviews/ReviewsFilter.vue";

export default {
  name: "ReviewsLaundry",
  props: {
    period: {
      type: String,
      default: "thismonth",
    },
    customDate: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ReviewsTitle,
    ReviewsFilter
  },
  data() {
    return {
      loading: false,
      overview: {},
      page: 1,
      searchQuery: "",
      total: null,
      feedback: [],
      showPagination: true,
      showSuggestionForm: false,
      filterParams: {
        clear: false,
        status: false,
        params: {},
        paramsLabel: {},
      },
      pagination: {
        from: null,
        to: null,
        total: null,
      },
      sort: {
        property: "name",
        direction: "asc",
      },
    };
  },
  computed: {
    stats() {
      let stats = [
        {
          label: "Total Reviews",
          figure: this.overview.feedback_count,
        },
        {
          label: "Overall Rating",
          figure: this.overview.feedback_average,
        },
      ];
      return stats;
    },
    sortedRatings() {
      if (!Array.isArray(this.overview?.feedback_percentage)) {
        return [];
      }

      return [...this.overview.feedback_percentage].sort((a, b) => b.rating - a.rating);
    },
    suggestions() {
      return formatSuggestions();
    },
    from() {
      return 1;
    },
    title() {
      return `${this.total} Reviews`;
    },
  },
  watch: {
    page() {
      this.getFeedback();
    },
    period() {
      if (this.period !== "custom") {
        this.getStats({ period: this.period });
      }
    },
    customDate() {
      this.getStats({ period: 'custom' });
    }
  },
  created() {
    this.getFeedback();
    this.getStats({ period: this.period });
    this.sortedRatings();
  },
  methods: {
    search(query) {
      this.searchQuery = query;
      const params = `page=${this.page}&service=laundry&search=${this.searchQuery}`;
      this.loading = true;
      feedback
        .index(params)
        .then((response) => {
          this.feedback = response.data.data.data;
          this.total = response.data.data.meta.total;
          this.showPagination = false;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.response.data.message);
        });
    },
    getStats({ period }) {
      this.loading = true;
      let payload = {};
      if (period === "custom") {
        payload = {
          service: "laundry",
          duration: period,
          start_date: this.customDate[0],
          end_date: this.customDate[1],
        };
      } else {
        payload = {
          service: "laundry",
          duration: period,
        };
      }
      feedback
        .summary(payload)
        .then((response) => {
          const { status, data } = response.data;
          if (status) {
            this.overview = data;
            this.statsPeriod = period;
            this.loading = false;
          }
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    getFeedback(params = "") {
      this.loading = true;
      const paramsPage = `page=${this.page}&` + `service=laundry` + `${params}`;
      feedback
        .index(paramsPage)
        .then((response) => {
          const { status, data } = response.data;
          if (status) {
            this.feedback = data.data;
            this.total = data.meta.total;
            this.pagination.from = data.meta.from;
            this.pagination.to = data.meta.to;
            this.pagination.total = data.meta.total;
            this.loading = false;
          }
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    filter({ params, paramsLabel }) {
      this.loading = true;
      let stringedParams = this.sortObjectAsParams(params) + "&service=laundry";
      if(stringedParams.includes("start_date") && stringedParams.includes("end_date")) {
        stringedParams = this.sortObjectAsParams(params) + `&duration=custom` + "&service=laundry";
      } 
      this.page = 1;
      this.filterParams = {
        status: true,
        params: { ...this.filterParams.params, ...params },
        paramsLabel: { ...this.filterParams.paramsLabel, ...paramsLabel },
      };
      stringedParams = stringedParams.replace(/\[\]/g, "");
      this.stringedParams = stringedParams;
      feedback
        .index(this.stringedParams)
        .then((response) => {
          this.filterParams = {
            status: true,
            params: params,
            paramsLabel: paramsLabel,
          };
          this.feedback = response.data?.data?.data;
          this.total = response.data.data.meta.total;
          // this.showPagination = false;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    clearFilter(key) {
      delete this.filterParams.params[key];
      delete this.filterParams.paramsLabel[key];

      const keys = this.filterParams.params;
      if (Object.keys(keys).length > 1) {
        this.filter({
          params: this.filterParams.params,
          paramsLabel: this.filterParams.paramsLabel,
        });
      } else {
        this.clearFilters();
      }
    },
    clearFilters() {
      this.filterParams = {
        clear: false,
        status: false,
        params: {},
        paramsLabel: {},
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.page-stat {
  border-bottom: 1px solid #f0f4f2;

  &--head {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    .title {
      color: var(--eden-grey-primary);
      font-size: 1rem;
      font-weight: 500;
    }

    .actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  &--periods {
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;

    li {
      cursor: pointer;
      color: var(--eden-grey-quaternary);
      font-weight: 400;
      font-size: 0.75rem;
      margin: 0 11px;

      &::marker {
        color: #cbd8d2;
      }

      &:first-child {
        list-style: none;
      }

      &.selected {
        color: #14b757;
        font-weight: 500;
      }

      &.disabled {
        cursor: not-allowed;
      }
    }
  }

  &--body {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #f0f4f2;
    padding: 25px 0;

    @media only screen and (max-width: 48em) {
      flex-direction: column;

      &>* {
        border: 1px solid #f0f4f2;
        margin: 5px 0;
      }
    }
  }

  &--card {
    padding: 30px 10px;
    transition: all 0.3s ease-in-out;

    @media only screen and (max-width: 48em) {
      padding: 10px;
    }

    .stat {
      &-figure {
        display: flex;
        align-items: center;
        color: var(--eden-grey-primary);
        margin-top: 15px;
        position: relative;

        h5 {
          &.small {
            font-size: 1.75rem;
          }
        }

        .stat-expand {
          cursor: pointer;
          position: absolute;
          opacity: 0;
          right: 25%;
          top: 10%;
        }

        span {
          font-size: 14px;
          line-height: 15.24px;

          &.stat-increase {
            color: #14b757;
          }

          &.stat-decrease {
            color: #f40529;
          }
        }
      }

      &-description {
        color: #4b6358;

        p {
          white-space: nowrap;
        }

        .body-text {
          font-weight: 400;
        }
      }
    }

    // @media (max-width: 756px) {
    //   margin: 20px;
    // }
  }

  &--more {
    display: none;

    @media only screen and (max-width: 48em) {
      display: block;
    }
  }
}
</style>
